/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PContact from "./../../common/models";
export enum TShareAcceptance {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2
}
export interface ITReceiverInfoArgs {
    email?: string;
    phone?: string;
    contactId?: string;
    userId?: string;
}
export class TReceiverInfo {
    public email?: string;
    public phone?: string;
    public contactId?: string;
    public userId?: string;
    constructor(args?: ITReceiverInfoArgs) {
        if (args != null && args.email != null) {
            this.email = args.email;
        }
        if (args != null && args.phone != null) {
            this.phone = args.phone;
        }
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TReceiverInfo");
        if (this.email != null) {
            output.writeFieldBegin("email", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.email);
            output.writeFieldEnd();
        }
        if (this.phone != null) {
            output.writeFieldBegin("phone", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.phone);
            output.writeFieldEnd();
        }
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TReceiverInfo {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.email = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_2: string = input.readString();
                        _args.phone = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.contactId = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_4: string = input.readString();
                        _args.userId = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TReceiverInfo(_args);
    }
}
export interface ITShareProfileRequestArgs {
    personas: Array<PContact.TAppPersona>;
    sharedContact: PContact.TAppContact;
    receiverContact: PContact.TAppContact;
    receiverInfo?: Array<TReceiverInfo>;
    sharedContactId?: string;
}
export class TShareProfileRequest {
    public personas: Array<PContact.TAppPersona>;
    public sharedContact: PContact.TAppContact;
    public receiverContact: PContact.TAppContact;
    public receiverInfo?: Array<TReceiverInfo>;
    public sharedContactId?: string;
    constructor(args: ITShareProfileRequestArgs) {
        if (args != null && args.personas != null) {
            this.personas = args.personas;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[personas] is unset!");
        }
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
        if (args != null && args.receiverContact != null) {
            this.receiverContact = args.receiverContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[receiverContact] is unset!");
        }
        if (args != null && args.receiverInfo != null) {
            this.receiverInfo = args.receiverInfo;
        }
        if (args != null && args.sharedContactId != null) {
            this.sharedContactId = args.sharedContactId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareProfileRequest");
        if (this.personas != null) {
            output.writeFieldBegin("personas", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.I32, this.personas.length);
            this.personas.forEach((value_5: PContact.TAppPersona): void => {
                output.writeI32(value_5);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 4);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        if (this.receiverContact != null) {
            output.writeFieldBegin("receiverContact", thrift.Thrift.Type.STRUCT, 5);
            this.receiverContact.write(output);
            output.writeFieldEnd();
        }
        if (this.receiverInfo != null) {
            output.writeFieldBegin("receiverInfo", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.receiverInfo.length);
            this.receiverInfo.forEach((value_6: TReceiverInfo): void => {
                value_6.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.sharedContactId != null) {
            output.writeFieldBegin("sharedContactId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.sharedContactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareProfileRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_7: Array<PContact.TAppPersona> = new Array<PContact.TAppPersona>();
                        const metadata_1: thrift.TList = input.readListBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_8: PContact.TAppPersona = input.readI32();
                            value_7.push(value_8);
                        }
                        input.readListEnd();
                        _args.personas = value_7;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_9: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_9;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_10: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.receiverContact = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_11: Array<TReceiverInfo> = new Array<TReceiverInfo>();
                        const metadata_2: thrift.TList = input.readListBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_12: TReceiverInfo = TReceiverInfo.read(input);
                            value_11.push(value_12);
                        }
                        input.readListEnd();
                        _args.receiverInfo = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_13: string = input.readString();
                        _args.sharedContactId = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.personas !== undefined && _args.sharedContact !== undefined && _args.receiverContact !== undefined) {
            return new TShareProfileRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareProfileRequest from input");
        }
    }
}
export interface ITShareProfileResponseArgs {
    success: boolean;
    vcfLink?: string;
    message?: string;
}
export class TShareProfileResponse {
    public success: boolean;
    public vcfLink?: string;
    public message?: string;
    constructor(args: ITShareProfileResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
        if (args != null && args.vcfLink != null) {
            this.vcfLink = args.vcfLink;
        }
        if (args != null && args.message != null) {
            this.message = args.message;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareProfileResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        if (this.vcfLink != null) {
            output.writeFieldBegin("vcfLink", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.vcfLink);
            output.writeFieldEnd();
        }
        if (this.message != null) {
            output.writeFieldBegin("message", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.message);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareProfileResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_14: boolean = input.readBool();
                        _args.success = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_15: string = input.readString();
                        _args.vcfLink = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_16: string = input.readString();
                        _args.message = value_16;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TShareProfileResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareProfileResponse from input");
        }
    }
}
export interface ITShareFieldRequestArgs {
    sharedContact: PContact.TAppContact;
    receiverContact: PContact.TAppContact;
    sharedContactId?: string;
    contact?: PContact.TAppContact;
    receiverInfo?: Array<TReceiverInfo>;
    isIntro?: boolean;
}
export class TShareFieldRequest {
    public sharedContact: PContact.TAppContact;
    public receiverContact: PContact.TAppContact;
    public sharedContactId?: string;
    public contact?: PContact.TAppContact;
    public receiverInfo?: Array<TReceiverInfo>;
    public isIntro?: boolean;
    constructor(args: ITShareFieldRequestArgs) {
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
        if (args != null && args.receiverContact != null) {
            this.receiverContact = args.receiverContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[receiverContact] is unset!");
        }
        if (args != null && args.sharedContactId != null) {
            this.sharedContactId = args.sharedContactId;
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        if (args != null && args.receiverInfo != null) {
            this.receiverInfo = args.receiverInfo;
        }
        if (args != null && args.isIntro != null) {
            this.isIntro = args.isIntro;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareFieldRequest");
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 5);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        if (this.receiverContact != null) {
            output.writeFieldBegin("receiverContact", thrift.Thrift.Type.STRUCT, 6);
            this.receiverContact.write(output);
            output.writeFieldEnd();
        }
        if (this.sharedContactId != null) {
            output.writeFieldBegin("sharedContactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.sharedContactId);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 2);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.receiverInfo != null) {
            output.writeFieldBegin("receiverInfo", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.receiverInfo.length);
            this.receiverInfo.forEach((value_17: TReceiverInfo): void => {
                value_17.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.isIntro != null) {
            output.writeFieldBegin("isIntro", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.isIntro);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareFieldRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_18: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_18;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_19: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.receiverContact = value_19;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_20: string = input.readString();
                        _args.sharedContactId = value_20;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_21: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_22: Array<TReceiverInfo> = new Array<TReceiverInfo>();
                        const metadata_3: thrift.TList = input.readListBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const value_23: TReceiverInfo = TReceiverInfo.read(input);
                            value_22.push(value_23);
                        }
                        input.readListEnd();
                        _args.receiverInfo = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_24: boolean = input.readBool();
                        _args.isIntro = value_24;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.sharedContact !== undefined && _args.receiverContact !== undefined) {
            return new TShareFieldRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareFieldRequest from input");
        }
    }
}
export interface ITShareFieldResponseArgs {
    success: boolean;
    vcfLink?: string;
    message?: string;
}
export class TShareFieldResponse {
    public success: boolean;
    public vcfLink?: string;
    public message?: string;
    constructor(args: ITShareFieldResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
        if (args != null && args.vcfLink != null) {
            this.vcfLink = args.vcfLink;
        }
        if (args != null && args.message != null) {
            this.message = args.message;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareFieldResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        if (this.vcfLink != null) {
            output.writeFieldBegin("vcfLink", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.vcfLink);
            output.writeFieldEnd();
        }
        if (this.message != null) {
            output.writeFieldBegin("message", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.message);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareFieldResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_25: boolean = input.readBool();
                        _args.success = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_26: string = input.readString();
                        _args.vcfLink = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_27: string = input.readString();
                        _args.message = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TShareFieldResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareFieldResponse from input");
        }
    }
}
export interface ITIntroRequestArgs {
    contactInfoAboutReceiverOne: PContact.TAppContact;
    contactInfoAboutReceiverTwo: PContact.TAppContact;
    receiverOneInfo?: Array<TReceiverInfo>;
    receiverTwoInfo?: Array<TReceiverInfo>;
}
export class TIntroRequest {
    public contactInfoAboutReceiverOne: PContact.TAppContact;
    public contactInfoAboutReceiverTwo: PContact.TAppContact;
    public receiverOneInfo?: Array<TReceiverInfo>;
    public receiverTwoInfo?: Array<TReceiverInfo>;
    constructor(args: ITIntroRequestArgs) {
        if (args != null && args.contactInfoAboutReceiverOne != null) {
            this.contactInfoAboutReceiverOne = args.contactInfoAboutReceiverOne;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactInfoAboutReceiverOne] is unset!");
        }
        if (args != null && args.contactInfoAboutReceiverTwo != null) {
            this.contactInfoAboutReceiverTwo = args.contactInfoAboutReceiverTwo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactInfoAboutReceiverTwo] is unset!");
        }
        if (args != null && args.receiverOneInfo != null) {
            this.receiverOneInfo = args.receiverOneInfo;
        }
        if (args != null && args.receiverTwoInfo != null) {
            this.receiverTwoInfo = args.receiverTwoInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TIntroRequest");
        if (this.contactInfoAboutReceiverOne != null) {
            output.writeFieldBegin("contactInfoAboutReceiverOne", thrift.Thrift.Type.STRUCT, 1);
            this.contactInfoAboutReceiverOne.write(output);
            output.writeFieldEnd();
        }
        if (this.contactInfoAboutReceiverTwo != null) {
            output.writeFieldBegin("contactInfoAboutReceiverTwo", thrift.Thrift.Type.STRUCT, 3);
            this.contactInfoAboutReceiverTwo.write(output);
            output.writeFieldEnd();
        }
        if (this.receiverOneInfo != null) {
            output.writeFieldBegin("receiverOneInfo", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.receiverOneInfo.length);
            this.receiverOneInfo.forEach((value_28: TReceiverInfo): void => {
                value_28.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.receiverTwoInfo != null) {
            output.writeFieldBegin("receiverTwoInfo", thrift.Thrift.Type.LIST, 4);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.receiverTwoInfo.length);
            this.receiverTwoInfo.forEach((value_29: TReceiverInfo): void => {
                value_29.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TIntroRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_30: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contactInfoAboutReceiverOne = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_31: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contactInfoAboutReceiverTwo = value_31;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_32: Array<TReceiverInfo> = new Array<TReceiverInfo>();
                        const metadata_4: thrift.TList = input.readListBegin();
                        const size_4: number = metadata_4.size;
                        for (let i_4: number = 0; i_4 < size_4; i_4++) {
                            const value_33: TReceiverInfo = TReceiverInfo.read(input);
                            value_32.push(value_33);
                        }
                        input.readListEnd();
                        _args.receiverOneInfo = value_32;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_34: Array<TReceiverInfo> = new Array<TReceiverInfo>();
                        const metadata_5: thrift.TList = input.readListBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_35: TReceiverInfo = TReceiverInfo.read(input);
                            value_34.push(value_35);
                        }
                        input.readListEnd();
                        _args.receiverTwoInfo = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactInfoAboutReceiverOne !== undefined && _args.contactInfoAboutReceiverTwo !== undefined) {
            return new TIntroRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TIntroRequest from input");
        }
    }
}
export interface ITIntroResponseArgs {
    success: boolean;
}
export class TIntroResponse {
    public success: boolean;
    constructor(args: ITIntroResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TIntroResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TIntroResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_36: boolean = input.readBool();
                        _args.success = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TIntroResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TIntroResponse from input");
        }
    }
}
export interface ITDismissShareSuggestionRequestArgs {
    userId: string;
}
export class TDismissShareSuggestionRequest {
    public userId: string;
    constructor(args: ITDismissShareSuggestionRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissShareSuggestionRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissShareSuggestionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_37: string = input.readString();
                        _args.userId = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined) {
            return new TDismissShareSuggestionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDismissShareSuggestionRequest from input");
        }
    }
}
export interface ITDismissShareSuggestionResponseArgs {
    success: boolean;
}
export class TDismissShareSuggestionResponse {
    public success: boolean;
    constructor(args: ITDismissShareSuggestionResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissShareSuggestionResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissShareSuggestionResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_38: boolean = input.readBool();
                        _args.success = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TDismissShareSuggestionResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDismissShareSuggestionResponse from input");
        }
    }
}
export interface ITBatchDismissShareSuggestionRequestArgs {
    userIds: Array<string>;
}
export class TBatchDismissShareSuggestionRequest {
    public userIds: Array<string>;
    constructor(args: ITBatchDismissShareSuggestionRequestArgs) {
        if (args != null && args.userIds != null) {
            this.userIds = args.userIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TBatchDismissShareSuggestionRequest");
        if (this.userIds != null) {
            output.writeFieldBegin("userIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.userIds.length);
            this.userIds.forEach((value_39: string): void => {
                output.writeString(value_39);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TBatchDismissShareSuggestionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_40: Array<string> = new Array<string>();
                        const metadata_6: thrift.TList = input.readListBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const value_41: string = input.readString();
                            value_40.push(value_41);
                        }
                        input.readListEnd();
                        _args.userIds = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userIds !== undefined) {
            return new TBatchDismissShareSuggestionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TBatchDismissShareSuggestionRequest from input");
        }
    }
}
export interface ITBatchDismissShareSuggestionResponseArgs {
    success: boolean;
}
export class TBatchDismissShareSuggestionResponse {
    public success: boolean;
    constructor(args: ITBatchDismissShareSuggestionResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TBatchDismissShareSuggestionResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TBatchDismissShareSuggestionResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_42: boolean = input.readBool();
                        _args.success = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TBatchDismissShareSuggestionResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TBatchDismissShareSuggestionResponse from input");
        }
    }
}
export interface ITShareAcceptanceRequestArgs {
    contactId: string;
    acceptance: TShareAcceptance;
}
export class TShareAcceptanceRequest {
    public contactId: string;
    public acceptance: TShareAcceptance;
    constructor(args: ITShareAcceptanceRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.acceptance != null) {
            this.acceptance = args.acceptance;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[acceptance] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareAcceptanceRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.acceptance != null) {
            output.writeFieldBegin("acceptance", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.acceptance);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareAcceptanceRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_43: string = input.readString();
                        _args.contactId = value_43;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_44: TShareAcceptance = input.readI32();
                        _args.acceptance = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined && _args.acceptance !== undefined) {
            return new TShareAcceptanceRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareAcceptanceRequest from input");
        }
    }
}
export interface ITShareAcceptanceResponseArgs {
    success: boolean;
}
export class TShareAcceptanceResponse {
    public success: boolean;
    constructor(args: ITShareAcceptanceResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TShareAcceptanceResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TShareAcceptanceResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_45: boolean = input.readBool();
                        _args.success = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TShareAcceptanceResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TShareAcceptanceResponse from input");
        }
    }
}
export interface ITBatchShareAcceptanceRequestArgs {
    acceptancedContactIds?: Array<string>;
    rejectedContactIds?: Array<string>;
}
export class TBatchShareAcceptanceRequest {
    public acceptancedContactIds?: Array<string>;
    public rejectedContactIds?: Array<string>;
    constructor(args?: ITBatchShareAcceptanceRequestArgs) {
        if (args != null && args.acceptancedContactIds != null) {
            this.acceptancedContactIds = args.acceptancedContactIds;
        }
        if (args != null && args.rejectedContactIds != null) {
            this.rejectedContactIds = args.rejectedContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TBatchShareAcceptanceRequest");
        if (this.acceptancedContactIds != null) {
            output.writeFieldBegin("acceptancedContactIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.acceptancedContactIds.length);
            this.acceptancedContactIds.forEach((value_46: string): void => {
                output.writeString(value_46);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.rejectedContactIds != null) {
            output.writeFieldBegin("rejectedContactIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.rejectedContactIds.length);
            this.rejectedContactIds.forEach((value_47: string): void => {
                output.writeString(value_47);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TBatchShareAcceptanceRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_48: Array<string> = new Array<string>();
                        const metadata_7: thrift.TList = input.readListBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const value_49: string = input.readString();
                            value_48.push(value_49);
                        }
                        input.readListEnd();
                        _args.acceptancedContactIds = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_50: Array<string> = new Array<string>();
                        const metadata_8: thrift.TList = input.readListBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const value_51: string = input.readString();
                            value_50.push(value_51);
                        }
                        input.readListEnd();
                        _args.rejectedContactIds = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TBatchShareAcceptanceRequest(_args);
    }
}
export interface ITBatchShareAcceptanceResponseArgs {
    success: boolean;
}
export class TBatchShareAcceptanceResponse {
    public success: boolean;
    constructor(args: ITBatchShareAcceptanceResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TBatchShareAcceptanceResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TBatchShareAcceptanceResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_52: boolean = input.readBool();
                        _args.success = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TBatchShareAcceptanceResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TBatchShareAcceptanceResponse from input");
        }
    }
}
export interface ITDenyFieldUpdateRequestArgs {
    contact: PContact.TAppContact;
    deniedUserIds: Array<string>;
}
export class TDenyFieldUpdateRequest {
    public contact: PContact.TAppContact;
    public deniedUserIds: Array<string>;
    constructor(args: ITDenyFieldUpdateRequestArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.deniedUserIds != null) {
            this.deniedUserIds = args.deniedUserIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deniedUserIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDenyFieldUpdateRequest");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.deniedUserIds != null) {
            output.writeFieldBegin("deniedUserIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.deniedUserIds.length);
            this.deniedUserIds.forEach((value_53: string): void => {
                output.writeString(value_53);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDenyFieldUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_54: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_54;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_55: Array<string> = new Array<string>();
                        const metadata_9: thrift.TList = input.readListBegin();
                        const size_9: number = metadata_9.size;
                        for (let i_9: number = 0; i_9 < size_9; i_9++) {
                            const value_56: string = input.readString();
                            value_55.push(value_56);
                        }
                        input.readListEnd();
                        _args.deniedUserIds = value_55;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined && _args.deniedUserIds !== undefined) {
            return new TDenyFieldUpdateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDenyFieldUpdateRequest from input");
        }
    }
}
export interface ITDenyFieldUpdateResponseArgs {
    success: boolean;
}
export class TDenyFieldUpdateResponse {
    public success: boolean;
    constructor(args: ITDenyFieldUpdateResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDenyFieldUpdateResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDenyFieldUpdateResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_57: boolean = input.readBool();
                        _args.success = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TDenyFieldUpdateResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDenyFieldUpdateResponse from input");
        }
    }
}
export interface ITGetViewersForFieldRequestArgs {
    contact: PContact.TAppContact;
}
export class TGetViewersForFieldRequest {
    public contact: PContact.TAppContact;
    constructor(args: ITGetViewersForFieldRequestArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetViewersForFieldRequest");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetViewersForFieldRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_58: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_58;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined) {
            return new TGetViewersForFieldRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetViewersForFieldRequest from input");
        }
    }
}
export interface ITGetViewersForFieldResponseArgs {
    idToContactMap: Map<string, PContact.TAppContact>;
    changePropagationTimestamp?: number | Int64;
}
export class TGetViewersForFieldResponse {
    public idToContactMap: Map<string, PContact.TAppContact>;
    public changePropagationTimestamp?: Int64;
    constructor(args: ITGetViewersForFieldResponseArgs) {
        if (args != null && args.idToContactMap != null) {
            this.idToContactMap = args.idToContactMap;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[idToContactMap] is unset!");
        }
        if (args != null && args.changePropagationTimestamp != null) {
            if (typeof args.changePropagationTimestamp === "number") {
                this.changePropagationTimestamp = new Int64(args.changePropagationTimestamp);
            }
            else {
                this.changePropagationTimestamp = args.changePropagationTimestamp;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetViewersForFieldResponse");
        if (this.idToContactMap != null) {
            output.writeFieldBegin("idToContactMap", thrift.Thrift.Type.MAP, 1);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.STRUCT, this.idToContactMap.size);
            this.idToContactMap.forEach((value_59: PContact.TAppContact, key_1: string): void => {
                output.writeString(key_1);
                value_59.write(output);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.changePropagationTimestamp != null) {
            output.writeFieldBegin("changePropagationTimestamp", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.changePropagationTimestamp);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetViewersForFieldResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_60: Map<string, PContact.TAppContact> = new Map<string, PContact.TAppContact>();
                        const metadata_10: thrift.TMap = input.readMapBegin();
                        const size_10: number = metadata_10.size;
                        for (let i_10: number = 0; i_10 < size_10; i_10++) {
                            const key_2: string = input.readString();
                            const value_61: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_60.set(key_2, value_61);
                        }
                        input.readMapEnd();
                        _args.idToContactMap = value_60;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_62: Int64 = input.readI64();
                        _args.changePropagationTimestamp = value_62;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.idToContactMap !== undefined) {
            return new TGetViewersForFieldResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetViewersForFieldResponse from input");
        }
    }
}
export interface ITGetVcfUrlRequestArgs {
    urlRaw: string;
    sigKey: string;
}
export class TGetVcfUrlRequest {
    public urlRaw: string;
    public sigKey: string;
    constructor(args: ITGetVcfUrlRequestArgs) {
        if (args != null && args.urlRaw != null) {
            this.urlRaw = args.urlRaw;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[urlRaw] is unset!");
        }
        if (args != null && args.sigKey != null) {
            this.sigKey = args.sigKey;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sigKey] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetVcfUrlRequest");
        if (this.urlRaw != null) {
            output.writeFieldBegin("urlRaw", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.urlRaw);
            output.writeFieldEnd();
        }
        if (this.sigKey != null) {
            output.writeFieldBegin("sigKey", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.sigKey);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetVcfUrlRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_63: string = input.readString();
                        _args.urlRaw = value_63;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_64: string = input.readString();
                        _args.sigKey = value_64;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.urlRaw !== undefined && _args.sigKey !== undefined) {
            return new TGetVcfUrlRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetVcfUrlRequest from input");
        }
    }
}
export interface ITGetVcfUrlResponseArgs {
    signedUrl: string;
}
export class TGetVcfUrlResponse {
    public signedUrl: string;
    constructor(args: ITGetVcfUrlResponseArgs) {
        if (args != null && args.signedUrl != null) {
            this.signedUrl = args.signedUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[signedUrl] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetVcfUrlResponse");
        if (this.signedUrl != null) {
            output.writeFieldBegin("signedUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.signedUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetVcfUrlResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_65: string = input.readString();
                        _args.signedUrl = value_65;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.signedUrl !== undefined) {
            return new TGetVcfUrlResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetVcfUrlResponse from input");
        }
    }
}
export interface ITDismissNotificationDataRequestArgs {
    notificationDataIds: Array<string>;
}
export class TDismissNotificationDataRequest {
    public notificationDataIds: Array<string>;
    constructor(args: ITDismissNotificationDataRequestArgs) {
        if (args != null && args.notificationDataIds != null) {
            this.notificationDataIds = args.notificationDataIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notificationDataIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissNotificationDataRequest");
        if (this.notificationDataIds != null) {
            output.writeFieldBegin("notificationDataIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.notificationDataIds.length);
            this.notificationDataIds.forEach((value_66: string): void => {
                output.writeString(value_66);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissNotificationDataRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_67: Array<string> = new Array<string>();
                        const metadata_11: thrift.TList = input.readListBegin();
                        const size_11: number = metadata_11.size;
                        for (let i_11: number = 0; i_11 < size_11; i_11++) {
                            const value_68: string = input.readString();
                            value_67.push(value_68);
                        }
                        input.readListEnd();
                        _args.notificationDataIds = value_67;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.notificationDataIds !== undefined) {
            return new TDismissNotificationDataRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDismissNotificationDataRequest from input");
        }
    }
}
export interface ITDismissNotificationDataResponseArgs {
    dismissed: boolean;
}
export class TDismissNotificationDataResponse {
    public dismissed: boolean;
    constructor(args: ITDismissNotificationDataResponseArgs) {
        if (args != null && args.dismissed != null) {
            this.dismissed = args.dismissed;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[dismissed] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissNotificationDataResponse");
        if (this.dismissed != null) {
            output.writeFieldBegin("dismissed", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.dismissed);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissNotificationDataResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_69: boolean = input.readBool();
                        _args.dismissed = value_69;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.dismissed !== undefined) {
            return new TDismissNotificationDataResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDismissNotificationDataResponse from input");
        }
    }
}
export interface ITGetSharedContactForNotificationDataRequestArgs {
    notificationDataId?: string;
}
export class TGetSharedContactForNotificationDataRequest {
    public notificationDataId?: string;
    constructor(args?: ITGetSharedContactForNotificationDataRequestArgs) {
        if (args != null && args.notificationDataId != null) {
            this.notificationDataId = args.notificationDataId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetSharedContactForNotificationDataRequest");
        if (this.notificationDataId != null) {
            output.writeFieldBegin("notificationDataId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.notificationDataId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetSharedContactForNotificationDataRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_70: string = input.readString();
                        _args.notificationDataId = value_70;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetSharedContactForNotificationDataRequest(_args);
    }
}
export interface ITGetSharedContactForNotificationDataResponseArgs {
    contact?: PContact.TAppContact;
}
export class TGetSharedContactForNotificationDataResponse {
    public contact?: PContact.TAppContact;
    constructor(args?: ITGetSharedContactForNotificationDataResponseArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetSharedContactForNotificationDataResponse");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetSharedContactForNotificationDataResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_71: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_71;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetSharedContactForNotificationDataResponse(_args);
    }
}
export interface ITDismissReverseIndexSuggestedShareRequestArgs {
    aclId?: string;
}
export class TDismissReverseIndexSuggestedShareRequest {
    public aclId?: string;
    constructor(args?: ITDismissReverseIndexSuggestedShareRequestArgs) {
        if (args != null && args.aclId != null) {
            this.aclId = args.aclId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissReverseIndexSuggestedShareRequest");
        if (this.aclId != null) {
            output.writeFieldBegin("aclId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.aclId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissReverseIndexSuggestedShareRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_72: string = input.readString();
                        _args.aclId = value_72;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDismissReverseIndexSuggestedShareRequest(_args);
    }
}
export interface ITDismissReverseIndexSuggestedShareResponseArgs {
    dismissed?: boolean;
}
export class TDismissReverseIndexSuggestedShareResponse {
    public dismissed?: boolean;
    constructor(args?: ITDismissReverseIndexSuggestedShareResponseArgs) {
        if (args != null && args.dismissed != null) {
            this.dismissed = args.dismissed;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDismissReverseIndexSuggestedShareResponse");
        if (this.dismissed != null) {
            output.writeFieldBegin("dismissed", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.dismissed);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDismissReverseIndexSuggestedShareResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_73: boolean = input.readBool();
                        _args.dismissed = value_73;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDismissReverseIndexSuggestedShareResponse(_args);
    }
}
export interface ITAddNearbyRequestArgs {
    receiverUserId?: string;
}
export class TAddNearbyRequest {
    public receiverUserId?: string;
    constructor(args?: ITAddNearbyRequestArgs) {
        if (args != null && args.receiverUserId != null) {
            this.receiverUserId = args.receiverUserId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddNearbyRequest");
        if (this.receiverUserId != null) {
            output.writeFieldBegin("receiverUserId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.receiverUserId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddNearbyRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_74: string = input.readString();
                        _args.receiverUserId = value_74;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddNearbyRequest(_args);
    }
}
export interface ITAddNearbyResponseArgs {
    success?: boolean;
}
export class TAddNearbyResponse {
    public success?: boolean;
    constructor(args?: ITAddNearbyResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddNearbyResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddNearbyResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_75: boolean = input.readBool();
                        _args.success = value_75;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddNearbyResponse(_args);
    }
}
export interface ITGetSharedContactRequestArgs {
    contactId: string;
}
export class TGetSharedContactRequest {
    public contactId: string;
    constructor(args: ITGetSharedContactRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetSharedContactRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetSharedContactRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_76: string = input.readString();
                        _args.contactId = value_76;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TGetSharedContactRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetSharedContactRequest from input");
        }
    }
}
export interface ITGetSharedContactResponseArgs {
    contact: PContact.TAppContact;
}
export class TGetSharedContactResponse {
    public contact: PContact.TAppContact;
    constructor(args: ITGetSharedContactResponseArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetSharedContactResponse");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetSharedContactResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_77: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_77;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined) {
            return new TGetSharedContactResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetSharedContactResponse from input");
        }
    }
}
export interface ITAppProfileViewerArgs {
    contact: PContact.TAppContact;
    isGranted: boolean;
}
export class TAppProfileViewer {
    public contact: PContact.TAppContact;
    public isGranted: boolean;
    constructor(args: ITAppProfileViewerArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.isGranted != null) {
            this.isGranted = args.isGranted;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isGranted] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppProfileViewer");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.isGranted != null) {
            output.writeFieldBegin("isGranted", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.isGranted);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppProfileViewer {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_78: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_78;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_79: boolean = input.readBool();
                        _args.isGranted = value_79;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined && _args.isGranted !== undefined) {
            return new TAppProfileViewer(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppProfileViewer from input");
        }
    }
}
export interface ITGetViewersForProfileRequestArgs {
    profileContact: PContact.TAppContact;
}
export class TGetViewersForProfileRequest {
    public profileContact: PContact.TAppContact;
    constructor(args: ITGetViewersForProfileRequestArgs) {
        if (args != null && args.profileContact != null) {
            this.profileContact = args.profileContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[profileContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetViewersForProfileRequest");
        if (this.profileContact != null) {
            output.writeFieldBegin("profileContact", thrift.Thrift.Type.STRUCT, 1);
            this.profileContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetViewersForProfileRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_80: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.profileContact = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.profileContact !== undefined) {
            return new TGetViewersForProfileRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetViewersForProfileRequest from input");
        }
    }
}
export interface ITGetViewersForProfileResponseArgs {
    viewers: Array<TAppProfileViewer>;
    nextUpdatePropagationTimeInMillis?: number | Int64;
}
export class TGetViewersForProfileResponse {
    public viewers: Array<TAppProfileViewer>;
    public nextUpdatePropagationTimeInMillis?: Int64;
    constructor(args: ITGetViewersForProfileResponseArgs) {
        if (args != null && args.viewers != null) {
            this.viewers = args.viewers;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[viewers] is unset!");
        }
        if (args != null && args.nextUpdatePropagationTimeInMillis != null) {
            if (typeof args.nextUpdatePropagationTimeInMillis === "number") {
                this.nextUpdatePropagationTimeInMillis = new Int64(args.nextUpdatePropagationTimeInMillis);
            }
            else {
                this.nextUpdatePropagationTimeInMillis = args.nextUpdatePropagationTimeInMillis;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetViewersForProfileResponse");
        if (this.viewers != null) {
            output.writeFieldBegin("viewers", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.viewers.length);
            this.viewers.forEach((value_81: TAppProfileViewer): void => {
                value_81.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.nextUpdatePropagationTimeInMillis != null) {
            output.writeFieldBegin("nextUpdatePropagationTimeInMillis", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.nextUpdatePropagationTimeInMillis);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetViewersForProfileResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_82: Array<TAppProfileViewer> = new Array<TAppProfileViewer>();
                        const metadata_12: thrift.TList = input.readListBegin();
                        const size_12: number = metadata_12.size;
                        for (let i_12: number = 0; i_12 < size_12; i_12++) {
                            const value_83: TAppProfileViewer = TAppProfileViewer.read(input);
                            value_82.push(value_83);
                        }
                        input.readListEnd();
                        _args.viewers = value_82;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_84: Int64 = input.readI64();
                        _args.nextUpdatePropagationTimeInMillis = value_84;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.viewers !== undefined) {
            return new TGetViewersForProfileResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetViewersForProfileResponse from input");
        }
    }
}
export interface ITUpdateProfileViewersRequestArgs {
    profileContact: PContact.TAppContact;
    allowedUserIds: Array<string>;
    deniedUserIds: Array<string>;
}
export class TUpdateProfileViewersRequest {
    public profileContact: PContact.TAppContact;
    public allowedUserIds: Array<string>;
    public deniedUserIds: Array<string>;
    constructor(args: ITUpdateProfileViewersRequestArgs) {
        if (args != null && args.profileContact != null) {
            this.profileContact = args.profileContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[profileContact] is unset!");
        }
        if (args != null && args.allowedUserIds != null) {
            this.allowedUserIds = args.allowedUserIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[allowedUserIds] is unset!");
        }
        if (args != null && args.deniedUserIds != null) {
            this.deniedUserIds = args.deniedUserIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deniedUserIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateProfileViewersRequest");
        if (this.profileContact != null) {
            output.writeFieldBegin("profileContact", thrift.Thrift.Type.STRUCT, 1);
            this.profileContact.write(output);
            output.writeFieldEnd();
        }
        if (this.allowedUserIds != null) {
            output.writeFieldBegin("allowedUserIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.allowedUserIds.length);
            this.allowedUserIds.forEach((value_85: string): void => {
                output.writeString(value_85);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.deniedUserIds != null) {
            output.writeFieldBegin("deniedUserIds", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.deniedUserIds.length);
            this.deniedUserIds.forEach((value_86: string): void => {
                output.writeString(value_86);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateProfileViewersRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_87: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.profileContact = value_87;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_88: Array<string> = new Array<string>();
                        const metadata_13: thrift.TList = input.readListBegin();
                        const size_13: number = metadata_13.size;
                        for (let i_13: number = 0; i_13 < size_13; i_13++) {
                            const value_89: string = input.readString();
                            value_88.push(value_89);
                        }
                        input.readListEnd();
                        _args.allowedUserIds = value_88;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_90: Array<string> = new Array<string>();
                        const metadata_14: thrift.TList = input.readListBegin();
                        const size_14: number = metadata_14.size;
                        for (let i_14: number = 0; i_14 < size_14; i_14++) {
                            const value_91: string = input.readString();
                            value_90.push(value_91);
                        }
                        input.readListEnd();
                        _args.deniedUserIds = value_90;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.profileContact !== undefined && _args.allowedUserIds !== undefined && _args.deniedUserIds !== undefined) {
            return new TUpdateProfileViewersRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateProfileViewersRequest from input");
        }
    }
}
export interface ITUpdateProfileViewersResponseArgs {
}
export class TUpdateProfileViewersResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateProfileViewersResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateProfileViewersResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateProfileViewersResponse();
    }
}
